var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSomeoneElse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#EDF5F1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#EDF5F1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4963 16.1465L51.7227 58.3464L65.5 68C77.2529 59.3935 74.0718 16.1465 59.4963 16.1465Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4954 16.1474C57.5519 14.9674 47.2949 11.9706 39.5059 16.1474C29.9276 21.2835 21.9897 46.8061 35.5012 65.5C35.5204 65.5265 45.0586 57.2368 45.0586 57.2368L61 25.5L59.4954 16.1474Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3347 53.1669H57.2743V50.573H41.727V53.1642C41.727 55.7028 41.7163 58.4621 39.5059 60.1312L32.5 62.0007L49.5006 84.9993C49.5006 84.9993 61.7388 62.0007 66.5 62.0007L59.4954 60.0923C57.3414 58.419 57.3347 55.6837 57.3347 53.1669Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3845 65.011C58.7897 65.1215 59.1546 65.1804 59.495 65.2091L64.5 61.4998L59.495 60.0935C57.3412 58.4202 57.3343 55.6847 57.3343 53.1679L57.3327 53.1034V50.5095L45.0581 50.574L41.7266 51.6845C43.9477 54.1834 50.7497 62.9288 58.3845 65.011Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0477 36.1358C65.0477 45.029 56.2031 56.1253 49.5004 56.1253C42.7977 56.1253 33.9531 45.029 33.9531 36.1358C33.9531 27.2426 40.914 23.9199 49.5004 23.9199C58.0868 23.9199 65.0477 27.2426 65.0477 36.1358Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0527 18.3672C49.6945 18.3672 51.7784 19.0682 53.4816 19.6825L53.6221 19.4777C53.6221 19.4777 53.8571 19.6572 54.2641 19.9684C55.2114 20.3181 55.9067 20.5881 55.9067 20.5881L55.6395 21.0212C59.9754 24.3421 69.8679 31.9391 70.7575 32.804C71.8998 33.9145 63.9033 62.2473 63.9033 46.1303C63.9033 32.6653 56.2081 29.9986 49.0527 28.3619C45.8161 27.6216 44.864 25.7707 44.4833 23.9199C44.1024 22.069 47.9102 18.3672 49.0527 18.3672Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7009 28.0982C42.5933 35.5852 38.3781 38.9734 34.4263 39.9686C32.2608 40.5138 33.2048 33.7847 33.2048 33.7847C33.2048 33.7847 36.2704 26.0131 36.6536 25.8237C37.0367 25.6341 40.1024 19 40.1024 19L47 24.6865L44.7009 28.0982Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4805 102.011C78.4242 102.011 79.9997 100.325 79.9997 98.2461V76.6535C79.9997 71.132 75.9776 65.2376 71.0616 63.555L63.7226 61.043C59.7741 64.2726 54.1314 68.6783 49.4999 68.6783C44.8685 68.6783 39.2257 64.2726 35.2773 61.043L27.9381 63.555C23.0221 65.2376 19 71.132 19 76.6535V98.2461C19 100.325 20.5755 102.011 22.5192 102.011H76.4805Z",
    fill: "#D7AE88"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomeoneElse);
export default __webpack_public_path__ + "static/media/someoneElse.6269c9ee5ed9ec4408ba4341e81cbad5.svg";
export { ForwardRef as ReactComponent };